export default __webpack_public_path__ + "static/media/Incontent_Banner_mobile.60cf25aa.webp";